export default {
    short: {},
    large: {},
    contentModuleRow: {
        display: 'flex',
    },
    contentModuleCell: {
        '&$short': {
            width: '35%',
            textAlign: 'right'
        },
        '&$large': {
            width: '65%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
    },
    priceNumbers: {
        font: "500 15px 'Roboto', sans-serif",
        color: '#5CA70A'
    }
}